import { FieldBuilder, FieldDefinition, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { GeneticMaterialService, SpacingService } from 'cbd-proxies';
import { Rotation } from '../rotation/rotation';

FieldBuilder.setNamespace('Geographic');

export const CYCLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('standLocationId', 'Entity.Cycle.StandLocationId')
    .required()
    .build(),
  FieldBuilder
    .number('cycleValue', 'Entity.Cycle.CycleValue')
    .required()
    .build(),
  FieldBuilder
    .date('plantationDate', 'Entity.Cycle.PlantationDate')
    .build(),
  FieldBuilder
    .number('plantationArea', 'Entity.Cycle.PlantationArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .date('startDate', 'Entity.Cycle.StartDate')
    .required()
    .build(),
  FieldBuilder
    .checkbox('isOwnPlantation', 'Entity.Cycle.IsOwnPlantation')
    .build(),
  FieldBuilder
    .checkbox('isLastCycle', 'Entity.Cycle.IsLastCycle')
    .build(),
  FieldBuilder
    .number('eucalyptusPercentage', 'Entity.Cycle.EucalyptusPercentage')
    .decimal()
    .build(),
  FieldBuilder
    .number('eucalyptusArea', 'Entity.Cycle.EucalyptusArea')
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'spacingId',
    'Entity.Spacing',
    SpacingService
  )
    .display('name')
    .displayFromNested('spacingName')
    .sortBy('spacingName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'geneticMaterialId',
    'Entity.GeneticMaterial',
    GeneticMaterialService
  )
    .display('name')
    .displayFromNested('geneticMaterialName')
    .sortBy('geneticMaterialName')
    .keyField('id')
    .build(),
];

export const CYCLE_CONFIG = {
  entityName: 'Cycle',
  localizationKey: 'Geographic::Entity.Cycle',
  fields: CYCLE_FIELDS,
  permission: 'PlanningGeography.Cycles',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
  children: [
    {
      entityName: 'Rotation',
      foreignKeyField: 'cycleId',
      localizationKey: 'Geographic::Entity.Rotation',
      component: Rotation,
    },
  ]
};
